import { render, staticRenderFns } from "./SelectionTable.vue?vue&type=template&id=4e867592"
import script from "./SelectionTable.vue?vue&type=script&lang=js"
export * from "./SelectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports